import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ExtensionForm } from '../extension-form';
import { useParams } from 'react-router-dom';
import { selectExtension } from '../../selectors';
import { updateExtension, getExtensionById, clearExtension } from '../../actions';
import { useHistory } from '../../../../components/navigation';
import { addToast } from '../../../core/actions';
import { ToastType } from '../../../core/constants';
import { localeService } from '../../../core';
export const AdminExtensionEdit = () => {
    const { id } = useParams();
    const extension = useSelector(selectExtension);
    const dispatch = useDispatch();
    const history = useHistory();
    const [disableBtn, setDisableBtn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            try {
                await dispatch(getExtensionById(id));
            }
            catch (e) {
                const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
                dispatch(addToast(ToastType.error, errorMessage));
            }
            setIsLoading(false);
        };
        fetchData();
        return () => {
            dispatch(clearExtension());
        };
    }, [id]);
    const handleSave = async (data) => {
        setDisableBtn(true);
        try {
            await dispatch(updateExtension(data));
        }
        catch (e) {
            const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
            dispatch(addToast(ToastType.error, errorMessage));
        }
        setDisableBtn(false);
        history.push(`/account/admin/extensions/list`);
    };
    return (<div>
      <header className="settings-header">
        <h2 className="header-title">
          <FormattedMessage id="account.administration.extentions.exit-extension"/>
        </h2>
      </header>
      <div>
        {!isLoading && (<ExtensionForm extension={extension} disableSubmitBtn={disableBtn} onSave={handleSave}/>)}
      </div>
    </div>);
};
